import {
  BEGIN_POLE_ANALYSIS,
  CALCULATE_POLE_ANALYSIS,
  CANCEL_POLE_ANALYSIS,
  ADD_FEATURE_POINT,
  ADD_FEATURE_POINT_MANUALLY,
  POINT_CHANGED,
  DELETE_POINT
} from './actions.type';
import {
  WINDOW_API_ERROR_SHOW,
  CREATE_DRAWN_FEATURE,
  SET_FEATURE_ENDING,
  END_DRAWING,
  WINDOW_NOTIFICATION_SHOW
} from './mutations.type';

import { Api as ApiAnalizy } from '../api/api-analizy';
import { Api as ApiReport } from '../api/api-raporty';
import MapLayerStyleBuilder from '../models/MapLayerStyleBuilder';
import ContextInstance from '../api/ContextInstance';
import SettingsInstance from '../api/SettingsInstance';
import GeoJSONFormat from 'ol/format/GeoJSON';
import { LineString, Point } from 'ol/geom';
import Feature from 'ol/Feature';

const apiAnalizy = new ApiAnalizy();
const apiReport = new ApiReport();

export const state = {
  ready: false,
  poleCostBuffor: null,
  nearestPoleBuffor: null,
  drawnFeature: null,
  numberOfPoles: null,
  polesAnalysisResult: null,
  pointInfrastructureLayer: null,
  drawingEnded: false,
  pointAdded: false,
  waitingForResponse: false,
  checkingCoordinates: false
};

export const actions = {
  async [BEGIN_POLE_ANALYSIS](context) {
    try {
      const configuration = await apiAnalizy.getAnalizySlupowEnergetycznychUstawienia(
        {
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null
        }
      );
      state.poleCostBuffor =
        configuration.body.dociaganie_koszt_wykorzystania_metry;
      state.nearestPoleBuffor =
        configuration.body.dociaganie_najblizszy_slup_metry;
      const pointInfrastructureLayer = context.getters.layers.find(
        l => l.datasource == 'PUNKTOWA_ISTNIEJACA'
      );

      if (!pointInfrastructureLayer.visible) {
        pointInfrastructureLayer.visible = true;
        pointInfrastructureLayer.mapLayer.setVisible(true);

        if (pointInfrastructureLayer.mapHighResolutionLayer) {
          pointInfrastructureLayer.mapHighResolutionLayer.setVisible(true);
        }
      }

      const apiStyle = context.rootGetters.styleForLayer(
        pointInfrastructureLayer.styleId
      );
      const selectStyle = new MapLayerStyleBuilder(
        apiStyle,
        pointInfrastructureLayer,
        true
      ).getStyle();
      pointInfrastructureLayer.mapLayer.setStyle(selectStyle);

      context.commit(CREATE_DRAWN_FEATURE);

      state.pointInfrastructureLayer = pointInfrastructureLayer;
      state.ready = true;
    } catch (e) {
      context.commit(WINDOW_API_ERROR_SHOW, 'Błąd pobierania danych.');
    }
  },
  async [ADD_FEATURE_POINT]({ state, dispatch }, pointCoordinates) {
    if (!state.ready || state.drawingEnded || state.checkCoordinates) {
      return;
    }

    const featureGeometry = state.drawnFeature.getGeometry();

    if (featureGeometry) {
      let coordinates = featureGeometry.getCoordinates();
      const lastPoint = state.pointAdded
        ? coordinates[coordinates.length - 1]
        : coordinates[coordinates.length - 2];

      if (
        lastPoint[0] == pointCoordinates[0] &&
        lastPoint[1] == pointCoordinates[1]
      ) {
        state.drawingEnded = true;
      } else {
        state.pointAdded = true;
        state.checkingCoordinates = true;

        setTimeout(async function() {
          const apiCoordinates = await dispatch(
            'checkCoordinates',
            pointCoordinates
          );
          const coordinatesChanged = !!apiCoordinates;

          if (coordinatesChanged) {
            coordinates = featureGeometry.getCoordinates();

            if (state.pointAdded) {
              featureGeometry.appendCoordinate(apiCoordinates);
              state.pointAdded = false;
            } else {
              coordinates[coordinates.length - 2] = apiCoordinates;
              state.drawnFeature.getGeometry().setCoordinates(coordinates);
            }
          }

          state.checkingCoordinates = false;
        }, 250);
      }
    } else {
      const apiCoordinates = await dispatch(
        'checkCoordinates',
        pointCoordinates
      );
      const coordinatesChanged = !!apiCoordinates;

      if (coordinatesChanged) {
        pointCoordinates = apiCoordinates;
      }

      state.drawnFeature.setGeometry(new LineString([pointCoordinates]));
      state.pointAdded = true;
    }
  },
  async [ADD_FEATURE_POINT_MANUALLY]({ state, dispatch }, pointCoordinates) {
    if (!state.ready || state.drawingEnded) {
      return;
    }

    pointCoordinates = await dispatch('checkCoordinates', pointCoordinates);

    if (!pointCoordinates) {
      return;
    }

    const featureGeometry = state.drawnFeature.getGeometry();

    if (featureGeometry) {
      featureGeometry.appendCoordinate(pointCoordinates);
    } else {
      state.drawnFeature.setGeometry(new LineString([pointCoordinates]));
    }

    state.pointAdded = true;
  },
  async [CALCULATE_POLE_ANALYSIS](context, { stake, generateReport }) {
    if (!state.drawingEnded) {
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'warn',
        title: 'Błąd.',
        message:
          'Przed obliczeniem lub wygenerowaniem raportu z analizy należy zakończyć rysowanie planowanego przebiegu inwestycji.',
        duration: 5000
      });

      return;
    }

    const formatter = new GeoJSONFormat();
    const drawnFeatureGeojson = formatter.writeFeatureObject(
      state.drawnFeature
    );

    const body = {
      ...drawnFeatureGeojson,
      stawka: stake.toString()
    };

    try {
      const response = await apiAnalizy.postAnalizySlupowEnergetycznychKosztWykorzystania(
        {
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          body: body,
          raport: generateReport
        }
      );

      state.numberOfPoles = response.body.wynik.ilosc_slopow;
      state.polesAnalysisResult = response.body.wynik.koszt;

      if (generateReport) {
        if (response.body.raport) {
          const reportId = response.body.raport.id;

          let intervalId = setTimeout(async function askForStatus() {
            const control = Date.now().toString();
            const result = await apiReport.getRaportyById({
              control: control,
              id: reportId
            });

            if (result && result.body && result.body.control == control) {
              if (result.body.raporty.status.value == 'generated') {
                const downloadUrl = `${SettingsInstance.baseApiUrl}/raporty/by_uuid/${result.body.raporty.uuid}?download=true`;
                window.location.href = downloadUrl;
              } else {
                intervalId = setTimeout(askForStatus, 10000);
              }
            }
          }, 0);
        }
      }

      return true;
    } catch (e) {
      context.commit(WINDOW_API_ERROR_SHOW, 'Błąd pobierania danych.');
    }
  },
  [CANCEL_POLE_ANALYSIS]({ state, rootGetters }) {
    state.drawnFeature = null;
    state.numberOfPoles = null;
    state.polesAnalysisResult = null;
    state.ready = false;
    state.drawingEnded = false;
    state.pointAdded = false;
    state.waitingForResponse = false;

    const apiStyle = rootGetters.styleForLayer(
      state.pointInfrastructureLayer.styleId
    );
    const selectStyle = new MapLayerStyleBuilder(
      apiStyle,
      state.pointInfrastructureLayer
    ).getStyle();
    state.pointInfrastructureLayer.mapLayer.setStyle(selectStyle);
  },
  async [POINT_CHANGED]({ state, dispatch }, { index, coordinates }) {
    coordinates = await dispatch('checkCoordinates', coordinates);

    if (!coordinates) {
      return;
    }

    const featureGeometry = state.drawnFeature.getGeometry();
    const featureCoordinates = featureGeometry.getCoordinates();
    featureCoordinates[index] = coordinates;
    featureGeometry.setCoordinates(featureCoordinates);
  },
  async [DELETE_POINT]({ state }, index) {
    const drawnFeatureCoordinates = state.drawnFeature
      .getGeometry()
      .getCoordinates();
    drawnFeatureCoordinates.splice(index, 1);
    state.drawnFeature.getGeometry().setCoordinates(drawnFeatureCoordinates);
    state.pointAdded = true;
  },
  async checkCoordinates({ state, commit }, pointCoordinates) {
    try {
      state.waitingForResponse = true;
      const pointFeature = new Feature(new Point(pointCoordinates));
      const geojsonPointFeature = new GeoJSONFormat().writeFeatureObject(
        pointFeature
      );
      const response = await apiAnalizy.postAnalizySlupowEnergetycznychNajblizszySlup(
        {
          wso2_id: this.contextEmail ? this.contextEmail : null,
          orgid: this.contextOrganizationId ? this.contextOrganizationId : null,
          body: geojsonPointFeature
        }
      );

      if (response.body && response.body.znaleziono) {
        const responseFeature = new GeoJSONFormat().readFeature(
          response.body.geojson
        );
        return responseFeature.getGeometry().getCoordinates();
      } else {
        return pointCoordinates;
      }
    } catch (err) {
      commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'warn',
        title: 'Błąd.',
        message:
          'Wystąpił błąd podczas sprawdzania współrzędnych do snapowania.',
        duration: 5000
      });
    } finally {
      state.waitingForResponse = false;
    }
  }
};

export const mutations = {
  [CREATE_DRAWN_FEATURE](state) {
    state.drawnFeature = new Feature();
  },
  [SET_FEATURE_ENDING](state, endPointCoordinates) {
    if (!state.ready || state.drawingEnded) {
      return;
    }

    const featureGeometry = state.drawnFeature.getGeometry();

    if (featureGeometry) {
      if (state.pointAdded) {
        featureGeometry.appendCoordinate(endPointCoordinates);
        state.pointAdded = false;
      } else {
        const coordinates = featureGeometry.getCoordinates();
        coordinates[coordinates.length - 1] = endPointCoordinates;
        featureGeometry.setCoordinates(coordinates);
      }
    }
  },
  [END_DRAWING](state) {
    state.drawingEnded = true;
  }
};

export const getters = {
  poleAnalysisReady() {
    return state.ready;
  },
  nearestPoleBuffor() {
    return state.nearestPoleBuffor;
  },
  numberOfPoles() {
    return state.numberOfPoles;
  },
  polesAnalysisResult() {
    return state.polesAnalysisResult;
  },
  poleAnalysisFeature(state) {
    return state.drawnFeature;
  },
  poleAnalysisWaitingForResponse(state) {
    return state.waitingForResponse;
  },
  poleAnalysisDrawingEnded(state) {
    return state.ready && state.drawingEnded;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
